<template>
    <!-- 회원 검색 결과 팝업 -->
    <div v-show='isShow' class='layer-pop square-type'  style="z-index: 999999">
        <div class='view-content'>
            <div class='scroll-area com-scroll-y'>
                <span class='sub-title'>회원 검색 결과</span>
                <div class='top-search-area'>
                    <div class='right'>
                        <input v-model='keyword' class='w220' placeholder="회원명, 연락처('-'제외)" type='text'
                               @keyup.enter='onClickBtnSearchCustomer'>
                        <button class='com-btn' @click='onClickBtnSearchCustomer'>검색</button>
                    </div>
                </div>
                <table class='com-table'>
                    <colgroup>
                        <col style='width: 70px;'>
                        <col style='width: 120px;'>
                        <col style='width: 120px;'>
                        <col style='width: 160px;'>
                        <col style='width: 160px;'>
                    </colgroup>
                    <thead>
                    <tr>
                        <th></th>
                        <th>회원명</th>
                        <th>닉네임</th>
                        <th>연락처</th>
                        <th>생년월일</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-if='customerList.length === 0'>
                        <td colspan='100'>등록된 내용이 없습니다.</td>
                    </tr>
                    <tr v-for='customer in customerList' v-else>
                        <td>
                            <div class='com-radio'>
                                <input :id='`member-radio-${customer.center_cust_id}`' name='member-radio'
                                       type='radio'
                                       @click='selectedCustomer = customer'>
                                <label :for='`member-radio-${customer.center_cust_id}`'></label>
                            </div>
                        </td>
                        <td>{{ customer.namee }}</td>
                        <td>{{ customer.nick_name }}</td>
                        <td>{{ customer.phone | customerPhoneFilter }}</td>
                        <td>{{ customer.birthday | dateFormatFilter }}</td>
                    </tr>
                    </tbody>
                </table>
                <!--                    <b-pagination  aria-controls="my-table" align="center" first-class="first" prev-class="prev" next-class="next" last-class="last"></b-pagination>-->
                <div class='bottom-btn'>
                    <button class='com-btn' @click='onClickBtnCancelSearchCustomerDlg'>취소</button>
                    <button class='com-btn blue' @click='onClickBtnSelectCustomer'>선택</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import { Utils } from '@/assets/js/utils';
import { pagingInfo } from '@/assets/js/common';
export default {
    name: 'SearchCustomerDlg',
    props: {
        centerId: [Number, String],
        isShow: Boolean,
        callbackSelect: Function,
        callbackCancel: Function,
    },
    data() {
        return {
            keyword: '',
            customerList: [],
            selectedCustomer: null,
            pagingInfo: {...pagingInfo},
        };
    },
    methods: {
        async onClickBtnSearchCustomer() {
            const keyword = this.keyword;

            this.customerList = [];
            this.selectedCustomer = null;

            if (keyword.trim().length == 0) {
                alert('회원명을 입력하세요.');
                return;
            }

            try {
                const { data } = await this.getCenterCustomer(keyword);
                this.customerList = data.items;
            } catch (e) {
                console.log(e);
            }
        },
        onClickBtnCancelSearchCustomerDlg() {
            this.callbackCancel();
            this.initData();
        },
        onClickBtnSelectCustomer() {
            if (Utils.isEmpty(this.selectedCustomer)) {
                alert('선택된 회원이 없습니다.');
                return false;
            }

            this.callbackSelect(this.selectedCustomer);
            this.initData();
        },
        getCenterCustomer(keyword = '') {
            console.log('test')
            const params = {
                searchStr: keyword,
                ...this.pagingInfo
            };
            console.log('test',params)
            return api.get(`/admin/api/center/${this.centerId}/customer`, { params });
        },
        initData() {
            this.keyword = '';
            this.customerList = [];
            this.selectedCustomer = null;
        },
    },
};
</script>

<style scoped>

</style>
